import { IEvent } from "@quest/adapter-interface";
import { Label, BaseCoreConstants, detectDeviceEnvironmentConstants, ingenuity } from "@quest/base-core/dist";
import { BaseViewBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { Container } from "@quest/pixi-bridge";
import { GameParserModel } from "../Platform/GameParserModel";

export class TopBarViewGame extends BaseViewBehavior {
    protected clock: Label
    private topbarContainer: Container;
    private topContainer: Container;
    private topbarleftContainer: Container;
    private topbarFullScreenCont: Container;
    private topbarSoundCont: Container;
    constructor(json: any) {
        super(json)
        this.initializeElement();
        this.hideClock();
        this.hideView();
    }
    public resize(evt: IEvent): void {
        const { availWidth } = evt.data;
        super.resize(evt);
        this.topContainer && (this.topContainer.y = ingenuity.configData.topBarElementsContainer);
        if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.LANDSCAPE) {
            this.pivot.set(ingenuity.configData.width / 2, 0);
            const scale = Math.min((window.innerHeight / ingenuity.configData.height), (window.innerWidth / ingenuity.configData.width));
            this.scale.set(scale, scale);
            this.x = availWidth * BaseCoreConstants.ANCHOR_CENTER;
            this.y = 0;

        }
        else if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
            const scale = Math.min(window.innerHeight / this.getShapeById("topBarPortraitResizer").height, window.innerWidth / this.getShapeById("topBarPortraitResizer").width);
            this.scale.set(scale, scale);
            this.pivot.set(this.getShapeById("topBarPortraitResizer").width / 2, 0);
            this.x = window.innerWidth / 2;
            this.y = 0
            if(!ingenuity.deviceEnv.isDesktop ){
                if(ingenuity.deviceEnv.getIsIpad()){
                this.topContainer && (this.topContainer.y = ingenuity.configData.topBarElementsContainer*2);
                 } }
        }
        if ((ingenuity.deviceEnv.getDeviceOS() == 'ios') && (!ingenuity.deviceEnv.getIsIpad())) {
            this.topbarContainer && (this.topbarContainer.x = 30);
        }
           if (!(ingenuity.parserModel as GameParserModel).getIsLobbyActive()) {
      this.topbarleftContainer && (this.topbarleftContainer.x = (this.topbarleftContainer.json as any).nonHomePosX);
    }
    if (!SlotConstantsBehavior.SHOW_GAME_CLOCK) {
      this.topbarSoundCont && (this.topbarSoundCont.x = (this.topbarSoundCont.json as any).ontarioX)
      this.topbarFullScreenCont && (this.topbarFullScreenCont.x = (this.topbarFullScreenCont.json as any ).orientation[ingenuity.deviceEnv.getOrientation()].ontarioX)
    }
        this.addViewOnTop();
    }
    /**
     * This method will initialize this class UI elements
     */
    protected initializeElement() {
        this.clock = this.getLabelById("topbarClock") as Label;
        this.topbarContainer = this.getContainerByID("topBarRightContainer") as Container
        this.topContainer=this.getContainerByID("topbarContainer") as Container
           this.topbarleftContainer = this.getContainerByID("topbarleftContainer") as Container;
    this.topbarFullScreenCont = this.getContainerByID("topbarFullScreenCont") as Container;
    this.topbarSoundCont = this.getContainerByID("topbarSoundCont") as Container;
    }

    /**
     * This method will add TopBar view on top of other view.
     */
    public addViewOnTop() {
        ingenuity.currentGame.stage.addChild(this);
    }
    /**
     * This method will update clock
     * @param evt
     */
    public updateClock(data: string) {
        this.clock.text = data;
    }
    /**
     * hide game clock
     */
    protected hideClock() {
        if (!SlotConstantsBehavior.SHOW_GAME_CLOCK) {
            this.clock.visible = false;
        }
    }
    public showView() {
        this.visible = true;
    }
    public hideView() {
        this.visible = false;
    }
}